import { render, staticRenderFns } from "./BalanceRefreshFailures.vue?vue&type=template&id=2df3b10b"
import script from "./BalanceRefreshFailures.vue?vue&type=script&lang=js"
export * from "./BalanceRefreshFailures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports